// src/components/UniversalHeader.jsx

import {
  Flex,
  Box,
  Image,
  Link,
  IconButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  DrawerCloseButton,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";

import { FiMenu } from "react-icons/fi";

import {
  Link as RouterLink,
  useLocation,
} from "react-router-dom";

export default function UniversalHeader({ title }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { pathname } = useLocation();

  const navItems = [
    {
      label: "🎟️ Find coupons",
      href: "/",
    },
    {
      label: "🗺️ Map",
      href: "/map",
    },
    {
      label: "🏢 For businesses",
      href: "/coupon-ads",
    },
    {
      label: "💷 Pricing",
      href: "/pricing",
    },
    {
      label: "🔐 Login",
      href: "/login",
    },
  ];

  const isActive = (href) => {
    if (href === "/") {
      return pathname === "/";
    }

    return (
      pathname === href ||
      pathname.startsWith(`${href}/`)
    );
  };

  return (
    <>
      {/* HEADER */}

      <Flex
        as="nav"
        align="center"
        justify="space-between"
        px={{
          base: 4,
          md: 6,
        }}
        py={4}
        boxShadow="sm"
        bg="white"
        position="sticky"
        top={0}
        zIndex={50}
      >
        {/* CLICKABLE LOGO + TITLE */}

        <Flex
          as={RouterLink}
          to="/"
          align="center"
          gap={3}
          flexShrink={0}
          textDecoration="none"
          _hover={{
            textDecoration: "none",
          }}
          aria-label="Go to Postcode Coupons homepage"
        >
          <Image
            src="/logo512.png"
            alt="Postcode Coupons"
            boxSize="40px"
            objectFit="contain"
          />

          <Box
            fontWeight="extrabold"
            fontSize={{
              base: "md",
              md: "lg",
            }}
            color="gray.900"
            letterSpacing="-0.02em"
          >
            {title || "postcode.coupons"}
          </Box>
        </Flex>

        {/* DESKTOP NAVIGATION */}

        <Flex
          gap={{
            md: 4,
            lg: 6,
          }}
          display={{
            base: "none",
            md: "flex",
          }}
          align="center"
        >
          {navItems.map((item) => {
            const active = isActive(item.href);

            return (
              <Link
                key={item.href}
                as={RouterLink}
                to={item.href}
                fontWeight={
                  active
                    ? "bold"
                    : "medium"
                }
                color={
                  active
                    ? "red.600"
                    : "gray.700"
                }
                borderBottom={
                  active
                    ? "2px solid"
                    : "2px solid transparent"
                }
                borderColor={
                  active
                    ? "red.500"
                    : "transparent"
                }
                pb={1}
                whiteSpace="nowrap"
                textDecoration="none"
                _hover={{
                  color: "red.600",
                  textDecoration: "none",
                }}
              >
                {item.label}
              </Link>
            );
          })}
        </Flex>

        {/* MOBILE MENU BUTTON */}

        <IconButton
          icon={<FiMenu />}
          display={{
            base: "flex",
            md: "none",
          }}
          onClick={onOpen}
          aria-label="Open menu"
          variant="ghost"
          color="red.600"
          fontSize="xl"
        />
      </Flex>

      {/* MOBILE DRAWER */}

      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
      >
        <DrawerOverlay />

        <DrawerContent>
          <DrawerCloseButton />

          <DrawerBody mt={12}>
            {/* MOBILE BRAND */}

            <Flex
              as={RouterLink}
              to="/"
              onClick={onClose}
              align="center"
              gap={3}
              mb={7}
              textDecoration="none"
              _hover={{
                textDecoration: "none",
              }}
            >
              <Image
                src="/logo512.png"
                alt="Postcode Coupons"
                boxSize="42px"
              />

              <Box>
                <Box
                  fontWeight="extrabold"
                  color="gray.900"
                >
                  postcode.coupons
                </Box>

                <Box
                  fontSize="xs"
                  color="gray.500"
                >
                  Coupons by postcode
                </Box>
              </Box>
            </Flex>

            <VStack
              align="stretch"
              spacing={2}
            >
              {navItems.map((item) => {
                const active = isActive(item.href);

                return (
                  <Link
                    key={item.href}
                    as={RouterLink}
                    to={item.href}
                    onClick={onClose}
                    width="100%"
                    px={4}
                    py={3}
                    borderRadius="lg"
                    fontSize="lg"
                    fontWeight={
                      active
                        ? "bold"
                        : "medium"
                    }
                    color={
                      active
                        ? "red.600"
                        : "gray.700"
                    }
                    bg={
                      active
                        ? "red.50"
                        : "transparent"
                    }
                    textDecoration="none"
                    _hover={{
                      bg: "red.50",
                      color: "red.600",
                      textDecoration: "none",
                    }}
                  >
                    {item.label}
                  </Link>
                );
              })}
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}